import React, { useState } from 'react';
import { auditLog } from '../data/mockData';

export default function AuditLog() {
  const [filter, setFilter] = useState('ALL');

  const steps = ['ALL', 'AUTH', 'STEP 1', 'STEP 2', 'STEP 3', 'STEP 4', 'STEP 5', 'STEP 6', 'RECONCILE'];
  const filtered = filter === 'ALL' ? auditLog : auditLog.filter(r => r.step === filter);

  const stepColor = step => {
    if (step === 'AUTH') return 'auth';
    if (step === 'RECONCILE') return 'reconcile';
    return '';
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div>
          <h2>Audit Log</h2>
          <p>All API calls and pipeline events · Run EMP-00127-ACME_20260415_143022Z</p>
        </div>
        <span className="badge badge-neutral" style={{ padding: '6px 14px' }}>{auditLog.length} entries</span>
      </div>

      {/* Filter */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 20 }}>
        {steps.map(s => (
          <button key={s} onClick={() => setFilter(s)}
            className={`btn btn-sm ${filter === s ? 'btn-primary' : 'btn-secondary'}`}>
            {s}
          </button>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Event Stream</h2>
          <span className="card-count">{filtered.length} entries</span>
        </div>
        <div className="audit-list">
          <div className="audit-row" style={{ background: 'var(--surface-2)', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.6px', color: 'var(--ink-4)' }}>
            <span>Timestamp</span>
            <span>Step</span>
            <span>Action / Endpoint</span>
            <span>HTTP</span>
            <span>Note</span>
          </div>
          {filtered.map((row, i) => (
            <div key={i} className="audit-row">
              <span className="audit-ts">{row.ts}</span>
              <span className={`audit-step-badge ${stepColor(row.step)}`}>{row.step}</span>
              <span className="audit-action">{row.action}</span>
              <span>
                {row.status === 200 && <span className="http-200">200</span>}
                {row.status === 404 && <span className="http-404">404</span>}
                {row.status === null && <span className="http-null">—</span>}
              </span>
              <span className="audit-note">{row.note}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
